<template>
  <div class="notice">
    <div class="title">
      <v-icon>announcement</v-icon>notice
      <!-- <router-link to="/notice?q=true">
        <button class="add_btn" v-if="isAdmin">글쓰기</button>
      </router-link> -->
    </div>
    <div class="notice_header">
      <div>작성일</div>
      <div>제&nbsp;&nbsp;목</div>
    </div>
    <div class="notice_contents">
      <div class="notice_content" v-for="(notice, n) in noticeList" :key="n">
        <div>{{parseDateFormat(notice.ymd)}}</div>
        <div @click="handleClick(notice)" class="notice_title">
          {{notice.title}}
        </div>
        <!-- <div class="noti_modi" @click="clickModi(notice)" v-if="isAdmin">[수정]</div> -->
      </div>
    </div>
    <div class="pagination_wrap">
      <Pagination
      :currentPage="currentPage"
      :totalPageNum="totalPageNum"
      @pageChange="pageChange"></Pagination>
    </div>
  </div>
</template>
  
<script>
  import Pagination from '@/components/pagination/Pagination'
  import { mapState, mapMutations, mapGetters } from 'vuex'
  import {parseDateFormat} from '@/assets/func'

  export default {
    name: 'noticeList',
    props: {
      isAdmin: Boolean,
      clickHandler: Function
    },
    components: {
      Pagination
    },
    methods: {
      ...mapMutations({
        setNoticePage: 'notice/SET_NOTICE_PAGE',
        setCurrentNoti: 'setCurrentNoti'
      }),
      // clickModi (notice) {
      //   this.setCurrentNoti(notice)
      //   this.$router.push('/notice?q=false')
      // },
      handleClick (notice) {
        this.clickHandler(notice)
      },
      pageChange (pNum) {
        this.setNoticePage(pNum)
      },
      parseDateFormat (date) {
        return parseDateFormat(date)
      }
    },
    computed: {
      ...mapState({
        totalCnt: state => state.notice.totalCnt,
        currentPage: state => state.notice.currentPage
      }),
      ...mapGetters({
        noticeList: 'getNotice'
      }),
      totalPageNum () {
        let pNum = parseInt(this.totalCnt / 10)
        return this.totalCnt % 10 === 0 ? pNum : pNum + 1
      }
    }
  }
</script>
  
<style scoped>
  .notice_header, .notice_contents {
    width: 95%;
    margin-left: auto;
    margin-right: auto;
  }
  .notice_header {
    display: flex;
    border-top: 2px solid #cee3f0;
    border-bottom: 2px solid #cee3f0;
    height: 30px;
    line-height: 30px;
    font-weight: 500;
  }
  .notice_header div:nth-child(1) {
    flex: 2;
    text-align: center;
    min-width: 75px !important;
  }
  .notice_header div:nth-child(2) {
    flex: 8;
    text-align: center;
  }

  .add_btn {
    float: right;
    margin-top: 3px;
    margin-right: 10px;
  }

  .notice .title {
    margin-left: 10px;
    height: 30px;
    line-height: 30px;
    color: #689f38;
    font-weight: 500;
  }
  .title i {
    vertical-align: middle;
    margin-right: 5px;
    color: #689f38;
  }

  .notice_contents {
    max-height: 260px;
  }
  .notice_content {
    position: relative;
    display: flex;
    height: 25px;
    line-height: 25px;
    border-bottom: 1px solid #cae1ef;
  }
  .notice_content:hover {
    background-color: rgba(0, 0, 0, 0.04) !important;
  }
  /* .notice_content:hover .noti_modi {
    display: block;
  } */
  .notice_content div:nth-child(1) {
    flex: 2;
    text-align: center;
    min-width: 75px !important;
  }
  /* .noti_modi {
    position: absolute;
    right: 10px;
    display: none;
  }
  .noti_modi:hover {
    cursor: pointer;
    color: #03a9f4
  } */

  .notice_title {
    flex: 8;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-left: 15px;
  }
  .notice_title:hover {
    cursor: pointer;
  }

  .pagination_wrap {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// NoticeList.vue?1a16e056